module.exports = __webpack_public_path__ + "static/predictably-irrational-the-hidden-forces-that-shape-our-decisions-ff7ba93b509e3e1cb3c75351e50cb0e2.jpg";